import { render, staticRenderFns } from "./hqglLogisticsInbound.vue?vue&type=template&id=75a0f640&scoped=true&"
import script from "./hqglLogisticsInbound.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsInbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a0f640",
  null
  
)

export default component.exports